<template>
    <div id="quoting-promoter-agente">
        <b-modal v-model="showModal" id="modal-cotizador" hide-footer size="xl" centered scrollable :title="titleModal"
                 ref="modal-serv">
            <upload-invoice
                :role_id="5"
                :type_invoice="0"
                :user_id="promoter_id"
                :is_sinister="false"
                :reg_id="quoting_id">
            </upload-invoice>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                      v-model="pagination.current_page" :total-rows="pagination.total"
                                      :per-page="pagination.per_page" aria-controls="my-table"
                                      v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <b-table sticky-header="80vh" responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                         :items="pagination.data" :filter="filter">
                    <template #cell(nombre)="{item}">
                        {{ item.nom_cont }} {{ item.paterno }} {{ item.materno }}
                    </template>
                    <template #cell(email)="{item}">
                        {{ item.email }}
                    </template>
                    <template #cell(estado)="{item}">
                        <span v-if="item.reledo">
                            {{ item.reledo.estado }}
                        </span>
                    </template>
                    <template #cell(ciudad)="{item}">
                         <span v-if="item.relcity">
                            {{ item.relcity.ciudad }}
                        </span>
                    </template>
                    <template #cell(telefono)="{item}">
                        {{ item.telefono }}
                    </template>
                    <template #cell(paquete)="{item}">
                        {{ item.relpackage.paquete }}
                    </template>
                    <template #cell(total)="{item}">
                        {{ item.prima_total }}
                    </template>
                    <template #cell(fecha)="{item}">
                        {{ item.fecha }}
                    </template>
                    <template #cell(status)="{item}">
                        <span v-if="item.approved_at!=null" class="badge rounded-pill text-bg-success">
                            <i class="fa-solid fa-circle-check"></i>
                        </span>
                        <span v-else class="badge rounded-pill text-bg-secondary">
                            <i class="fa-solid fa-circle-pause"></i>
                        </span>
                        <!-- SI EXISTE LA FACTURA  -->
                        <span v-if="item.s_f_p===1" class="badge rounded-pill text-bg-secondary">
                            <i class="fa-solid fa-file-invoice-dollar"></i>
                        </span>
                        <!-- SI EXISTE EL TICKET  -->
                        <span v-if="item.s_c_p===1" class="badge rounded-pill text-bg-success">
                            <i class="fa-solid fa-receipt"></i>
                        </span>
                    </template>
                    <template #cell(acciones)="{item}">
                        <div class="dropdown">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-cogs"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="javascript:void(0)"
                                   v-on:click="quoting_id=item.id;openModalsProviders('invoice_quoter_promoter')">
                                    Factura Comisión
                                </a>
                            </div>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </main>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";

import {quotersService} from "../../Services/Quoters.service";

export default {
    name: "quoting-promoter-agent",
    mixins: [myMixins],
    props: {
        promoter_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            filter: null,
            params: {
                limit: 10,
                page: 1,
                where: [{
                    field: 'promoter_id',
                    operator: '=',
                    value: this.promoter_id
                }, {
                    field: 'approved_at',
                    operator: '!=',
                    value: 0
                }, {
                    field: 's_c_p',
                    operator: '=',
                    value: 0
                }]
            },
            fields: [
                {key: 'Nombre'},
                {key: 'email'},
                {key: 'estado'},
                {key: 'ciudad'},
                {key: 'telefono'},
                {key: 'paquete'},
                {key: 'total'},
                {key: 'fecha'},
                {key: 'status'},
                {key: 'acciones'},
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            quoting_id: 0,
        }
    },
    methods: {

        async index() {
            this.isBusy = true;
            this.pagination = await quotersService.getMany(this.params);
            this.isBusy = false;
        },

        changeLimit() {
            this.index();
        },

        onChange(page) {
            this.params.page = page;
            this.index();
        },

    },
    mounted() {
        //console.log('mounted');
        this.index();
    },
}
</script>

<style scoped>


</style>
